import * as yup from "yup";
import { Schema } from "../../schema";
import { MultipleValueObject } from "../base-value-object";
export class HumanName extends MultipleValueObject {
    familyName;
    familyNameKana;
    givenName;
    givenNameKana;
    constructor(args) {
        super(args);
        this.familyName = args.familyName;
        this.familyNameKana = args.familyNameKana;
        this.givenName = args.givenName;
        this.givenNameKana = args.givenNameKana;
    }
    validator(args) {
        return this.validate(args, HumanName.schema);
    }
    equals(t) {
        return this.toString() === t?.toString();
    }
    getValue() {
        return {
            familyName: this.familyName,
            familyNameKana: this.familyNameKana,
            givenName: this.givenName,
            givenNameKana: this.givenNameKana,
        };
    }
    toString() {
        return `${this.familyName} ${this.givenName} (${this.familyNameKana} ${this.givenNameKana})`;
    }
    static schema(required = true) {
        return Schema.required({
            familyName: yup.string().min(1).max(32).label("姓"),
            familyNameKana: yup.string().min(1).max(32).kana().label("姓カナ"),
            givenName: yup.string().min(1).max(32).label("名"),
            givenNameKana: yup.string().min(1).max(32).kana().label("名カナ"),
        }, required);
    }
}
//# sourceMappingURL=human-name.js.map